оGJl<template>
    <div ref="map"
        style="width: 100%; height: 100%">

        <v-menu
          v-model="showMenu"
          :position-x="x"
          :position-y="y"
          :close-on-click="false"
          :close-on-content-click="false"
          absolute
          offset-y
          max-width=500
        >
          <v-list style="z-index: 12">
            <v-list-item v-if="rhm_selected !== null">
              <v-btn
                depressed
                color="success"
                @click="plot_selected"
              >
                {{ this.$i18n.t('templates.add') }}
              </v-btn>
            </v-list-item>

            <v-list-item>
              <v-data-table
                :headers="headers"
                :items="rows"
                hide-default-footer
                hide-default-header
                :items-per-page="15"
                dense
              >
              </v-data-table>
            </v-list-item>

          </v-list>
        </v-menu>
    </div>
</template>

<script>
  import View from 'ol/View'
  import Map from 'ol/Map'
  import TileLayer from 'ol/layer/WebGLTile';
  import { Vector as VectorLayer } from 'ol/layer.js';
  import VectorSource from 'ol/source/Vector.js';
  import { transform } from 'ol/proj.js'
  import OSM from 'ol/source/OSM.js';
  import GeoJSON from 'ol/format/GeoJSON';
  import limits from './limits.js'
  import styles from './styles.js'
  import * as turf from '@turf/turf';
  var moment = require('moment-timezone');
  var RBF = require('rbf');

  import 'ol/ol.css';

  export default {
    name: 'MapComponent',
    components: {},
    mixins: [ limits, styles ],
    
    props: {
      city: String,
      pdk: Object,
      nodehost: String,
      variable: Object,
      varspace: String,
      aggrunit: String,
      aggrunits: Array,
      background_stations: Object,
      filter_level: Number,
      netatmo_vars: Array,
      filtering: Boolean,
      datetime: Object,
      show_netatmo: Boolean,
      show_rhm: Boolean,
      show_air: Boolean,
      show_lyrs: Array,
      standardize: Boolean,
      confidence: Number,
      interp: String,
      transparency: Number
    },
    data: () => ({
      items: ['Hell yeah', 'Yell hell'],
      showMenu: false,
      x: 0,
      y: 0,
      map: null,
      load_counter: 0,
      iso_lyr: null,
      rhm_lyr: null,
      air_lyr: null,
      rhm_hovered: null,
      rhm_selected: null,
      netatmo_lyr: null,
      netatmo_hovered: null,
      netatmo_selected: null,
      is_russian: true,
      headers: [
        { text: 'Показатель', value: 'variable' },
        { text: 'Значение',   value: 'value' }
      ],
      rows: [],
      dataarr: {
        meteo: null,
        air: null
      },
      vars: {
        meteo: {
          temperature: 'temp',
          humidity: 'humirel',
          pressure: 'pressea',
          cloud: 'cloudtot',
          wind: 'windspd',
          prec: 'prec03',
          pet: 'pet',
          mrt: 'mrt',
          utci: 'utci'
        },
        air: {
          nh3: 'nh3',
          susp_sol: 'susp_sol',
          pm10: 'pm10',
          pm25: 'pm25',
          no2: 'no2',
          so2: 'so2',
          o3: 'o3',
          co: 'co',
          ch4: 'ch4',
          h2s: 'h2s',
          no: 'no',
          c6h6: 'c6h6',
          c10h8: 'c10h8',
          c8h8: 'c8h8',
          c7h8: 'c7h8',
          c6h5oh: 'c6h5oh',
          ch2o: 'ch2o',
        }
      },
      var_mean: {
        meteo: {
          temperature: null,
          humidity: null,
          pressure: null,
          cloud: null,
          wind: null,
          prec: null,
          pet: null,
          mrt: null,
          utci: null
        },
        air: {
          nh3: null,
          susp_sol: null,
          pm10: null,
          pm25: null,
          no2: null,
          so2: null,
          o3: null,
          co: null,
          ch4: null,
          h2s: null,
          no: null,
          c6h6: null,
          c10h8: null,
          c8h8: null,
          c7h8: null,
          c6h5oh: null,
          ch2o: null,
        }
      },
      iso_step: {
        meteo: {
          temperature: 1,
          humidity: 5,
          pressure: 2.5,
          cloud: 1,
          wind: 1,
          prec: null,
          pet: 1,
          mrt: 1,
          utci: 1
        },
        air: {
          nh3: 0.2,
          susp_sol: 0.2,
          pm10: 0.2,
          pm25: 0.2,
          no2: 0.2,
          so2: 0.2,
          o3: 0.2,
          co: 0.2,
          ch4: 0.2,
          h2s: 0.2,
          no: 0.2,
          c6h6: 0.2,
          c10h8: 0.2,
          c8h8: 0.2,
          c7h8: 0.2,
          c6h5oh: 0.2,
          ch2o: 0.2
        }
      },
      baseLayer: null,
      canvas: null,
      raster_lyr: null,
      warnedNoBackground: false,
      centers: {
        moscow: [37.6, 55.7],
        spb: [30.3, 59.9]
      }
    }),
    watch: { 

      '$i18n.locale': function() {
        this.rhm_lyr.changed();
      },
      
      load_counter(newval) {
        if (newval == 0) {
          this.$emit('set_loading_map', false);
          console.log(this.dataarr)
        }
      },

      confidence() {
        this.rhm_lyr.changed();
        this.air_lyr.changed();
        this.update_isolines(this.dataarr[this.varspace]);
      },
      
      show_lyrs: function() {
        if (this.show_lyrs.includes('points')) {
          this.netatmo_lyr.setVisible(this.show_netatmo);
          this.rhm_lyr.setVisible(this.show_rhm);
        } else {
          this.netatmo_lyr.setVisible(false);
          this.rhm_lyr.setVisible(false);
        }

        if (this.show_lyrs.includes('fields')) {
          this.iso_lyr.setVisible(true);
        } else {
          this.iso_lyr.setVisible(false);
        }
      },
      show_netatmo: function() {
        if (this.show_lyrs.includes('points')) 
          this.netatmo_lyr.setVisible(this.show_netatmo);
      },
      show_rhm: function() {
        if (this.show_lyrs.includes('points')) 
          this.rhm_lyr.setVisible(this.show_rhm);
      },
      filtering: function() {
        this.netatmo_lyr.changed();
      },
      filter_level: function() {
        this.netatmo_lyr.changed();
      },
      aggrunit: function() {
        this.load_data('rhm');
        this.load_data('air');
        if (this.aggrunit == 'hour') {
          this.load_data('netatmo');
          this.netatmo_lyr.setVisible(this.show_netatmo);
        } else {
          this.netatmo_lyr.setVisible(false);
        }
      },
      datetime: {
        handler() {
          this.load_data('rhm');
          this.load_data('air');
          if (this.aggrunit == 'hour')
            this.load_data('netatmo');
        },
        deep: true
      },
      city: {
        handler() {
          this.load_data('rhm');
          this.load_data('air');
          if (this.aggrunit == 'hour')
            this.load_data('netatmo');
          this.map.setView(
            new View({
              zoom: 9,
              center: transform(this.centers[this.city], 'EPSG:4326', 'EPSG:3857'),
            }),
          )
        },
        deep: true
      },
                  varspace() {
        this.rhm_lyr.changed();
        this.air_lyr.changed();
        this.update_varmean();
        this.update_isolines(this.dataarr[this.varspace]);

        this.rhm_lyr.setVisible(this.varspace == 'meteo');
        this.air_lyr.setVisible(this.varspace == 'air');
      },
      variable: {
        handler() {
          if (this.aggrunit == 'hour') {
            this.netatmo_lyr.changed();
            this.rhm_lyr.changed();
            this.air_lyr.changed();
            this.update_isolines(this.dataarr[this.varspace]);
          } else {
            this.load_data('rhm');
            this.load_data('air');
          }
        },
        deep: true
      },
                        standardize: function() {
        this.warnedNoBackground = false;
        this.air_lyr.changed();
        this.rhm_lyr.changed();
        this.netatmo_lyr.changed();
        this.update_varmean();
        this.update_isolines(this.dataarr[this.varspace]);
      },
      interp: function() {
        this.update_isolines(this.dataarr[this.varspace]);
      },
      background_stations: {
        handler() {
          this.update_varmean();
          this.update_isolines(this.dataarr[this.varspace]);
          // Force re-render of point layers to update colors/values with new var_mean
          this.rhm_lyr.changed();
          this.air_lyr.changed();
          this.netatmo_lyr.changed();
        },
        deep: true
      },
      transparency(val) {
        if (this.baseLayer) {
          this.baseLayer.setOpacity(val / 100);
        }
      },
    },
    methods: {

      prepare_menu(feature, source) {

        // console.log(feature);

        this.rows = [];

        this.rows.push({
          variable: this.$i18n.t('templates.network'),
          value: source == 'rhm' ? this.$i18n.t('templates.rhm.title') : this.$i18n.t('templates.netatmo.title')
        })

        let template = source == 'rhm' ? this.$i18n.t('templates.rhm') : this.$i18n.t('templates.netatmo');
        let value = null;

        for (let key in template.labels) {

          if (this.aggrunit != 'hour') {
            if (Object.keys(this.vars[this.varspace]).includes(key) && key != this.variable[this.varspace]) {
              continue;
            } else if (key == 'time') {
              this.rows.push({
                variable: this.$i18n.t('titles.period'),
                value: this.aggrunits.filter(unit => unit.value == this.aggrunit)[0].text
              });
              continue;
            }
          }

          switch(key) {
            case 'name':
              value = feature.get(this.$i18n.t('fields.stname'));
              break
            case 'date':
              var date = moment(feature.get('datetime'));
              switch (this.aggrunit) {
                case 'year':
                  value = date.format('YYYY');
                  break;
                case 'month':
                  value = date.format('YYYY-MM');
                  break;
                case 'week':
                  value = date.format('YYYY-MM-DD') + ' — ' + date.add(6, 'days').format('YYYY-MM-DD');
                  break;
                default:
                  value = date.format('YYYY-MM-DD');
                  break
              }
              break
            case 'time':
              value = moment(feature.get('datetime')).hours();
              break
            default:
              value = feature.get(key);
              break
          }

          if (['temperature', 'pressure', 'mrt', 'utci', 'pet'].includes(key) && value !== null)
            value = value.toFixed(1);

          this.rows.push({
            variable: template.labels[key],
            value: value != null ? value.toString().concat(' ', template.units[key]) : '—'
          })
        }
      },

      show_menu(e) {
        e.preventDefault();
        this.x = e.pixel[0];
        this.y = e.pixel[1];
        this.showMenu = true;
      },

      plot_selected() {
        this.$emit('plot_selected');
        this.showMenu = false;
        this.rhm_selected.setStyle(this.rhm_style());
        this.rhm_selected = null;
      },

      empty_layer(style, declutter=true) {
        return new VectorLayer({
          source: new VectorSource({
            format: new GeoJSON(),
            features: []
          }),
          style: style,
          declutter: declutter
        });
      },

      // Solution by Evan Carroll https://stackoverflow.com/a/54335525
      * range(start, end, step) {
        let state = start;
        while (state < end) {
          yield state;
          state += step;
        }
        return;
      },

      sequence(min, max, step) {
        let start = min - min % step;
        let end = max + step - max % step;
        return Array.from(this.range(start, end, step));
      },

                  async update_isolines(input) {

        // Guard: no data yet — skip (e.g. background_stations watcher fires before spatial data loads)
        if (!input || !input.features) {
          return;
        }

        var self = this;

        this.load_counter += 1;

        try {

          let data = structuredClone(input);



                    // Server returns data in one of two formats:
                    // 1. With named columns (meteo: temperature, pet, etc.) — get_rhm / get_rhm_stats
                    // 2. With generic 'param_avg' column (air) — get_air / get_air_stats
                    // Detect which format by checking if the first feature has 'param_avg'
                    let which_var = input.features.length > 0 && 'param_avg' in input.features[0].properties
                      ? 'param_avg'
                      : this.variable[this.varspace];

          // Проверяем, есть ли у данных поле confidence
          const hasConfidence = data.features.length > 0 && 'confidence' in data.features[0].properties;

          if (hasConfidence) {
            data.features = data.features.filter(feature => 
              feature.properties.confidence >= this.confidence && !(feature.properties[which_var] == null || isNaN(feature.properties[which_var]))
            );
          } else {
            data.features = data.features.filter(feature => 
              !(feature.properties[which_var] == null || isNaN(feature.properties[which_var]))
            );
          }

          var div = this.varspace == 'meteo' ? 1.0 : this.pdk[this.variable[this.varspace]];

                    data.features.forEach(feature => feature.properties[which_var] /= div);

                    if (data.features.length > 0) {

            var grid = null;

            if (this.interp == 'RBF') {

              var points = data.features.map(feature => transform(feature.geometry.coordinates, 'EPSG:4326', 'EPSG:3857'));
              var values = data.features.map(feature => feature.properties[which_var]);
              
              var rbf = RBF(points, values, 'linear');

              var box = turf.bbox(data);

              grid = turf.pointGrid(box, 2, {properties: {}});

              grid.features.forEach(function(feature, index) {
                this[index].properties = {};
                this[index].properties[self.variable[self.varspace]] = rbf(transform(this[index].geometry.coordinates, 'EPSG:4326', 'EPSG:3857'))[0];
              }, grid.features);

            } else {
              var options = {
                gridType: 'points', 
                property: this.variable[this.varspace], 
                units: 'meters', 
                weight: 3
              };
              grid = turf.interpolate(data, 2000, options);
            }

            let min = Math.min.apply(null, data.features.map(feature => feature.properties[which_var]));
            let max = Math.max.apply(null, data.features.map(feature => feature.properties[which_var]));

            if (this.standardize) {
              var varm = this.var_mean[this.varspace][this.variable[this.varspace]];
              if (varm === null) {
                // No background data, clear isolines
                this.iso_lyr.getSource().clear();
                this.iso_lyr.changed();
                this.load_counter -= 1;
                return;
              }
              min -= varm / div;
              max -= varm / div;
              for (let feature of grid.features)
                feature.properties[this.variable[this.varspace]] = feature.properties[this.variable[this.varspace]] - varm / div;
            }
              
            var breaks = this.sequence(min, max, this.iso_step[this.varspace][this.variable[this.varspace]]); 

            const isolines = turf.isolines(grid, breaks, {zProperty: this.variable[this.varspace]});

            isolines.features = isolines.features.filter(feature => feature.geometry.coordinates.length > 0);

            const features = new GeoJSON({ dataProjection: 'EPSG:4326', featureProjection: 'EPSG:3857' }).readFeatures(isolines);
            const isosource = this.iso_lyr.getSource();
            isosource.clear();
            isosource.addFeatures(features);

            
                                        } else {
                                          // Показываем снекбар только если данные отсеялись именно фильтром confidence,
                                          // а не из-за отсутствия значений по переменной (все null).
                                          // Для этого проверяем, сколько features осталось бы без учёта confidence.
                                          const which_var = input.features.length > 0 && 'param_avg' in input.features[0].properties
                                            ? 'param_avg'
                                            : this.variable[this.varspace];
                                          const hasConfidence = input.features.length > 0 && 'confidence' in input.features[0].properties;
                                          const featuresWithValues = input.features.filter(f => 
                                            !(f.properties[which_var] == null || isNaN(f.properties[which_var]))
                                          );
                                          
                                          if (hasConfidence && featuresWithValues.length > 0) {
                                            let conf = input.features.map(feature => feature.properties.confidence).filter(value => value != null);
                                            if (conf.length > 0) {
                                              this.$emit('show_snackbar', Math.floor(Math.max(...conf) / 5) * 5);
                                            }
                                          }
                                          this.iso_lyr.getSource().clear();
                                        }

          this.iso_lyr.changed();

        } catch (error) {
          console.error('Error in update_isolines:', error);
        } finally {
          this.load_counter -= 1;
        }
        
      },

            async load_data(src) {

        if (this.datetime != null) {
          var lyr = undefined
          switch (src) {
            case 'rhm':
              lyr = this.rhm_lyr;
              break;
            case 'air':
              lyr = this.air_lyr;
              break;
            case 'netatmo':
              lyr = this.netatmo_lyr;
              break;
            default:
              lyr = this.rhm_lyr;
              break;
          }
          
          this.$emit('set_loading_map', true);
          this.load_counter += 1;
          this.warnedNoBackground = false;

          var to_load = src == 'air' ? 'air' : 'meteo';

          try {
            // Формируем данные для POST-запроса
            const requestData = {
              action: 'get',
              dimension: 'spatial',
              city: this.city,
              source: src,
              aggrunit: this.aggrunit,
              scope: 'each',
              variable: this.vars[to_load][this.variable[to_load]],
              datetime: this.aggrunit == 'hour' ? `'${this.datetime.format()}'::timestamptz` : this.datetime.format('YYYY-MM-DD')
            };

            // Выполняем запрос с await fetch
            const response = await fetch(this.nodehost, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json; charset=utf-8'
              },
              body: JSON.stringify(requestData)
            });

            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            
            const features = new GeoJSON({ dataProjection: 'EPSG:4326', featureProjection: 'EPSG:3857' }).readFeatures(data);
            const source = lyr.getSource();
            source.clear();
            source.addFeatures(features);
            lyr.changed();

            if (src == 'rhm') {
              this.dataarr['meteo'] = data;
              this.update_varmean();
              if (this.varspace == 'meteo')
                this.update_isolines(data);
            } else if (src == 'air') {
              this.dataarr['air'] = data;
              this.update_varmean();
              if (this.varspace == 'air')
                this.update_isolines(data);
            }

          } catch (error) {
            console.error('Error loading data for source ' + src + ':', error);
          } finally {
            this.load_counter -= 1;
          }
        }
      },
                              update_varmean() {

        this.load_counter += 1;

        try {

                    // Use the appropriate layer for the current varspace
          var targetLyr = this.varspace == 'air' ? this.air_lyr : this.rhm_lyr;

                    // For air, use air-specific backstage IDs (backstage.air_moscow / backstage.air_spb)
                    var features = targetLyr
                      .getSource()
                      .getFeatures()
                      .filter(
                        feature => this.background_stations[this.varspace][this.city].includes(feature.get('id'))
                      );

                    if (features.length > 0) {
            for (let v in this.vars[this.varspace]) {
              let back_sum = 0;
              let back_count = 0;
              for (let f of features) {
                // For air: named columns for hourly data, 'param_avg' for aggregated
                let value;
                if (this.varspace == 'air') {
                  value = f.get('param_avg');
                  // If no param_avg, try named column
                  if (value === undefined || value === null) {
                    value = f.get(v);
                  }
                } else {
                  value = f.get(v);
                }
                
                if (!isNaN(value) && value != null) {
                  back_sum += value;
                  back_count++;
                }
              }

              if (back_count > 0) {
                this.var_mean[this.varspace][v] = back_sum / back_count;
              } else {
                this.var_mean[this.varspace][v] = null;
              }
            }

            // Reset warning flag when background is found for the current variable
            if (this.var_mean[this.varspace][this.variable[this.varspace]] !== null) {
              this.warnedNoBackground = false;
            }

            // Show warning if background data missing for current variable and standardize is on
            if (this.standardize && this.var_mean[this.varspace][this.variable[this.varspace]] === null && !this.warnedNoBackground) {
              this.warnedNoBackground = true;
              this.$emit('show_snackbar', this.$t('messages.no_background_data'));
    }
  } else {
    for (let v in this.vars[this.varspace]) {
              this.var_mean[this.varspace][v] = null;
    }

    // Show warning if no background stations found at all and standardize is on
    if (this.standardize && !this.warnedNoBackground) {
              this.warnedNoBackground = true;
              this.$emit('show_snackbar', this.$t('messages.no_background_data'));
    }
  }

        } catch (error) {
          console.error('Error in update_varmean:', error);
        } finally {
          this.load_counter -= 1;
        }
      }
    },

    mounted() {
      this.rhm_lyr = this.empty_layer(this.rhm_style());
      this.netatmo_lyr = this.empty_layer(this.netatmo_style());
      this.iso_lyr = this.empty_layer(this.iso_style(), false);
      this.air_lyr = this.empty_layer(this.air_style(),);

      // var extent = [0, 0, width, height];
      // this.canvas = document.createElement('canvas');
      // canvas.width = width;
      // canvas.height = height;
      // const ctx = canvas.getContext('2d');
      // const imageData = ctx.createImageData(width, height);
      // for (let i = 0; i < imageData.data.length; i += 4) {
      //   // Modify pixel data
      //   imageData.data[i + 0] = getRandomInt(255);  // R value
      //   imageData.data[i + 1] = getRandomInt(255);    // G value
      //   imageData.data[i + 2] = getRandomInt(255);  // B value
      //   imageData.data[i + 3] = 255;// getRandomInt(255);  // A value
      // }
      // // Draw image data to the canvas
      // ctx.putImageData(imageData, 0, 0);
      // var dataURL = canvas.toDataURL();

      // this.raster_lyr = new ol.layer.Image({
      //   source: new ol.source.ImageStatic({
      //     url: dataURL,
      //     projection: 'EPSG:3857',
      //     imageExtent: extent
      //   })
      // })

      this.baseLayer = new TileLayer({
        source: new OSM(),
        opacity: this.transparency / 100
      });
      this.map = new Map({
        target: this.$refs['map'],
        layers: [
          this.baseLayer,
          this.iso_lyr,
          this.netatmo_lyr,
          this.air_lyr,
          this.rhm_lyr
        ],
        view: new View({
          zoom: 9,
          center: transform(this.centers[this.city], 'EPSG:4326', 'EPSG:3857'),
        }),
      });

      this.load_data('rhm');
      this.load_data('netatmo');
      this.load_data('air');
    
      var self = this;

      self.map.on('pointermove', function(evt) {
        var netatmo_features = [];
        var rhm_features = [];
        var air_features = [];

        self.map.forEachFeatureAtPixel(evt.pixel, function (feature, layer) {
            if (layer === self.rhm_lyr) {
              rhm_features.push(feature);
              return true;
            }
            if (layer === self.netatmo_lyr) {
              netatmo_features.push(feature);
              return true;
            } 
            if (layer === self.air_lyr) {
              air_features.push(feature);
              return true;
            } 
        });

        var rhm_current = null;
        if (rhm_features.length > 0) {
          rhm_current = rhm_features[0];
          if (self.netatmo_hovered != null) {
            self.netatmo_hovered.setStyle(self.netatmo_style());
            self.netatmo_hovered = null;
          }
        }

        if (self.rhm_hovered != rhm_current) {
          if (self.rhm_hovered != null && self.rhm_hovered != self.rhm_selected) {
            self.rhm_hovered.setStyle(self.rhm_style());
          }
          if (rhm_current != null) {
            rhm_current.setStyle(self.rhm_style(true));
          }
          self.rhm_hovered = rhm_current;
        }

        if (self.rhm_hovered == null) {
          var net_current = netatmo_features[0];
          if (self.netatmo_hovered != net_current) {
            if (self.netatmo_hovered != null && self.netatmo_hovered != self.netatmo_selected) {
              self.netatmo_hovered.setStyle(self.netatmo_style());
            }
            if (net_current != null) {
              net_current.setStyle(self.netatmo_style(true));
            }
            self.netatmo_hovered = net_current;
          }
        }

        if (rhm_features.length + netatmo_features.length > 0) {
          self.$refs.map.style.cursor = 'pointer';
        } else {
          self.$refs.map.style.cursor = '';
        }
      });

      self.map.on('click', function(evt) {
        var netatmo_features = [];
        var rhm_features = [];

        self.map.forEachFeatureAtPixel(evt.pixel, function (feature, layer) {
            if (layer === self.rhm_lyr) {
              rhm_features.push(feature);
              return true;
            }
            if (layer === self.netatmo_lyr) {
              netatmo_features.push(feature);
              return true;
            }
            
        });

        if (self.rhm_selected !== null) {
          self.rhm_selected.setStyle(self.rhm_style());
          self.rhm_selected = null;
        }

        if (self.netatmo_selected !== null) {
          self.netatmo_selected.setStyle(self.netatmo_style());
          self.netatmo_selected = null;
        }

        if (rhm_features.length > 0) {
          self.rhm_selected = rhm_features[0];
          self.rhm_selected.setStyle(self.rhm_style(true));
          self.$emit('select', self.rhm_selected.get('id'));

          self.prepare_menu(self.rhm_selected, 'rhm')
          self.show_menu(evt);

        } else if (netatmo_features.length > 0) {
          self.netatmo_selected = netatmo_features[0];
          self.netatmo_selected.setStyle(self.netatmo_style(true));

          self.prepare_menu(self.netatmo_selected, 'netatmo')
          self.show_menu(evt);
        } else {
          self.showMenu = false;
        }
        
      });
    }
  }
</script>
